import { replace } from 'svelte-spa-router'
import StorageService from './storage.service'

export default function(err, res) {

    if(err && (!res || !res.body || (res.body.error.key === 'accessRequired' || res.body.error.key === 'tokenExpired')))
        logout()

    if(!res.success && res.error && (res.error.key === 'tokenExpired' || res.error.key === 'accessRequired'))
        logout()
}

function logout() {
    StorageService.deleteItem('user')
    StorageService.deleteItem('access')
    replace('#/')
}